// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__8oxNr","label":"Labeled_label__2ux_s","divider":"Labeled_divider__1JhTk"};